export default "__VITE_ASSET__520a8f58__"